export default function navbarReducer(
    state: any = {
        navbar: 0,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Change the actual state of the navigation bar buttons
         */
        case 'NAVBAR_SET_STATE' : {
            return { ...state, navbar: action.payload }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/navbar.ts